const CART_FINALIZED_STATUS = 410;

const hasFinalizedCartError = (error: object) => {
  const errorCode =
    "error" in error && typeof error.error === "string" ? error.error : null;
  const status =
    "status" in error && typeof error.status === "number" ? error.status : null;

  return status === CART_FINALIZED_STATUS || errorCode === "cart_finalized";
};

export const isCartFinalizedError = (error: unknown): boolean => {
  if (typeof error !== "object" || error === null) {
    return false;
  }

  if (hasFinalizedCartError(error)) {
    return true;
  }

  if (!("cause" in error)) {
    return false;
  }

  return isCartFinalizedError(error.cause);
};
